export const RIGHTS_HOLDER_DOMAINS = {
  connectImg: 'connect.img',
  alulaXi: 'alula.xi.com'
}
